import styled from 'styled-components';

export const ConfirmationEbonPageContainer = styled.main`
    .congratulation-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 44px auto;
        max-width: 565px;
        text-align: center;

        & h1 {
            margin-bottom: 16px;
            font-size: 40px;
            text-transform: uppercase;
            color: ${props => props.theme.primary};
        }

        & h1::after {
            display: none;
        }

        & > button {
            margin-top: 32px;
            font-weight: 400;
        }

        p b {
            color: ${props => props.theme.primary};
            font-weight: ${props => props.theme.regularWeight};
        }

        .bt {
            margin-top: 25px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPageStyle.js